const initialState = () => ({
  franchise: null,
  franchises: [],
  pagination: {},
  status: null
})

export default initialState
